import React from 'react';
import { FiX } from 'react-icons/fi';
import Modal from './Modal';
import '../pages/CRM.css';

/**
 * Shared CRM dialog chrome — Google Calendar–style header/footer layout.
 */
export default function CrmModalShell({
  open,
  onClose,
  title,
  subtitle,
  icon: Icon,
  children,
  footer,
  size = 'md',
  className = '',
  ariaLabel,
  confirmClose = false,
}) {
  const sizeClass =
    size === 'lg' ? 'crm-modal--lg' : size === 'sm' ? 'crm-modal--sm' : 'crm-modal--md';

  return (
    <Modal
      open={open}
      onClose={onClose}
      confirmClose={confirmClose}
      ariaLabel={ariaLabel || title}
      overlayClassName="crm-modal-overlay"
      contentClassName={`crm-modal ${sizeClass} ${className}`.trim()}
    >
      <div className="modal-header crm-modal-header">
        {Icon ? (
          <span className="crm-modal-header-icon" aria-hidden>
            <Icon />
          </span>
        ) : null}
        <div className="crm-modal-header-text">
          <h2 className="crm-modal-title">{title}</h2>
          {subtitle ? <p className="crm-modal-subtitle">{subtitle}</p> : null}
        </div>
        <button
          type="button"
          className="crm-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <FiX />
        </button>
      </div>
      <div className="modal-body crm-modal-body">{children}</div>
      {footer ? <div className="modal-footer crm-modal-footer">{footer}</div> : null}
    </Modal>
  );
}
